/*
 *
 * EasySplit constants
 *
 */

import { SETTLE_NOW_SUCCESS } from 'utils/constants';

export const BASE_ACTION_CONSTANT = 'app/Vendors';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SET_ACTIVE_NAVIGATION = `${BASE_ACTION_CONSTANT}/SET_ACTIVE_NAVIGATION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const SEARCH_VENDORS = `${BASE_ACTION_CONSTANT}/SEARCH_VENDORS`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const SAVE_VENDORS = `${BASE_ACTION_CONSTANT}/SAVE_VENDORS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const SETTLEMENT_CONFIG = `${BASE_ACTION_CONSTANT}/SETTLEMENT_CONFIG`;
export const SAVE_SETTLEMENT_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_SETTLEMENT_CONFIG`;

export const CREATE_VENDOR = `${BASE_ACTION_CONSTANT}/CREATE_VENDOR`;
export const CREATE_VENDOR_NEW = `${BASE_ACTION_CONSTANT}/CREATE_VENDOR_NEW`;
export const CREATE_VENDOR_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/CREATE_VENDOR_RESPONSE`;

export const UPDATE_VENDOR = `${BASE_ACTION_CONSTANT}/UPDATE_VENDOR`;
export const UPDATE_VENDOR_NEW = `${BASE_ACTION_CONSTANT}/UPDATE_VENDOR_NEW`;
export const UPDATE_VENDOR_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/UPDATE_VENDOR_RESPONSE`;

export const BATCH_UPLOAD_SUBMIT = `${BASE_ACTION_CONSTANT}/BATCH_UPLOAD_SUBMIT`;
export const BATCH_UPLOAD_SAVE_RESPONSE = `${BASE_ACTION_CONSTANT}/BATCH_UPLOAD_SAVE_RESPONSE`;

export const RESET_BATCH_UPLOAD_RESPONSE = `${BASE_ACTION_CONSTANT}/RESET_BATCH_UPLOAD_RESPONSE`;

export const BATCH_DOWNLOAD = `${BASE_ACTION_CONSTANT}/BATCH_DOWNLOAD`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const VENDOR_DATA_BY_ID = `${BASE_ACTION_CONSTANT}/VENDOR_DATA_BY_ID`;
export const SAVE_VENDOR_DATA_BY_ID = `${BASE_ACTION_CONSTANT}/SAVE_VENDOR_DATA_BY_ID`;
export const RESET_VENDOR_DATA_BY_ID = `${BASE_ACTION_CONSTANT}/RESET_VENDOR_DATA_BY_ID`;

export const GET_VENDOR_OD_BALANCE = `${BASE_ACTION_CONSTANT}/GET_VENDOR_OD_BALANCE`;
export const INITIATE_VENDOR_OD = `${BASE_ACTION_CONSTANT}/INITIATE_VENDOR_OD`;

export const CREATE_KYC = `${BASE_ACTION_CONSTANT}/CREATE_KYC`;
export const DOWNLOAD_DOC = `${BASE_ACTION_CONSTANT}/DOWNLOAD_DOC`;
export const GET_VENDOR_KYC_DOCS = `${BASE_ACTION_CONSTANT}/GET_VENDOR_KYC_DOCS`;
export const GET_BUSINESS_INFO = `${BASE_ACTION_CONSTANT}/GET_BUSINESS_INFO`;

export const GET_DOCS_BY_USER = `${BASE_ACTION_CONSTANT}/GET_DOCS_BY_USER`;

export const SAVE_VENDOR_DOCS = `${BASE_ACTION_CONSTANT}/SAVE_VENOR_DOCS`;

export const UPLOAD_VENDOR_DOCS = `${BASE_ACTION_CONSTANT}/UPLOAD_VENDOR_DOCS`;

export const VERIFY_PAN = `${BASE_ACTION_CONSTANT}/VERIFY_PAN`;

export const VERIFY_CIN = `${BASE_ACTION_CONSTANT}/VERIFY_CIN`;

export const VERIFY_GST = `${BASE_ACTION_CONSTANT}/VERIFY_GST`;

export const CREATE_ONBOARDING_USER = `${BASE_ACTION_CONSTANT}/CREATE_ONBOARDING_USER`;

export const EASY_SPLIT_STATUS = {
  ACTIVE: 'ACTIVE',
  HOLD: 'HOLD',
  NOT_ACTIVE: 'NOT_ACTIVE',
  REQUESTED: 'REQUESTED',
};

export const HEADINGS = {
  EASY_SPLIT_ALL: [
    {
      key: 'txTime',
      displayName: 'Date & Time',
    },
    {
      key: 'merchantVendor',
      displayName: 'Vendor ID',
    },
    {
      key: 'name',
      displayName: 'Account Holder Name',
    },
    {
      key: 'balance',
      displayName: 'Unsettled Balance',
      align: 'right',
    },
    {
      key: 'nextSettlementDate',
      displayName: 'Next Settlement cycle',
    },
    {
      key: 'settleNowBtn',
      displayName: '',
    },
    {
      key: 'txStatus',
      displayName: 'Status',
    },
    {
      key: 'editVendorCTA',
      displayName: '',
    },
  ],
  EASY_SPLIT_BATCH: [
    {
      key: 'txTime',
      displayName: 'Date & Time',
    },
    {
      key: 'fileName',
      displayName: 'File Name',
    },
    {
      key: 'paymentCount',
      displayName: 'Payment Count',
    },
    {
      key: 'rowCount',
      displayName: 'Row Count',
    },
    {
      key: 'fileRefId',
      displayName: 'File Ref. ID',
    },
    {
      key: 'status',
      displayName: 'Status',
    },
  ],
};

export const HEADINGS_INCREMENTAL_ONBOARDING = {
  EASY_SPLIT_ALL: [
    {
      key: 'txTime',
      displayName: 'Creation Date',
      tooltip: {
        message: 'Creation Date',
      },
    },
    {
      key: 'merchantVendor',
      displayName: 'Vendor ID',
      tooltip: {
        message: 'Vendor ID',
      },
    },
    {
      key: 'name',
      displayName: 'Account Holder Name',
      tooltip: {
        message: 'Account Holder Name',
      },
    },
    {
      key: 'balance',
      displayName: 'Unsettled Balance',
      align: 'right',
      tooltip: {
        message: 'Unsettled Balance',
      },
    },
    {
      key: 'nextSettlementDate',
      displayName: 'Next Settlement cycle',
      tooltip: {
        message: 'Next Settlement cycle',
      },
    },
    // {
    //   key: 'settleNowBtn',
    //   displayName: '',
    //   width: 0.1,
    // },
    {
      key: 'txStatus',
      displayName: 'Status',
    },
    {
      key: 'completeActivationCTA',
      displayName: '',
      align: 'center',
    },
    {
      key: 'editVendorCTA',
      displayName: '',
    },
  ],
  EASY_SPLIT_BATCH: [
    {
      key: 'txTime',
      displayName: 'Date & Time',
      width: 0.15,
    },
    {
      key: 'fileName',
      displayName: 'File Name',
      width: 0.22,
    },
    {
      key: 'paymentCount',
      displayName: 'Payment Count',
      width: 0.12,
    },
    {
      key: 'rowCount',
      displayName: 'Row Count',
      width: 0.1,
    },
    {
      key: 'fileRefId',
      displayName: 'File Ref. ID',
      width: 0.22,
    },
    {
      key: 'status',
      displayName: 'Status',
      width: 0.1,
    },
  ],
};

export const ALL_CTA = 'ADD_VENDOR';
export const BATCH_CTA = 'BATCH';

export const SEARCH_EASY_SPLIT_BATCH_URL = {
  url: '/pg/orders/batch/search',
  method: 'GET',
};

export const CREATE_VENDOR_URL = {
  url: '/pg/settlements/split/vendors',
  method: 'POST',
};

export const CREATE_VENDOR_URL_NEW = {
  url: '/pg/settlements/split/vendor-kyc',
  method: 'POST',
};

export const UPDATE_VENDOR_URL = {
  url: `/pg/settlements/split/vendors/$vendor_id$`,
  method: 'PATCH',
};

export const BATCH_UPLOAD_URL = {
  url: '/pg/settlements/split/vendors/batch',
  method: 'POST',
};

export const GET_VENDOR_OD_BALANCE_URL = {
  url: '/pg/settlements/split/ondemand/vendor-balance',
  method: 'GET',
};

export const INITIATE_VENDOR_OD_URL = {
  url: '/pg/settlements/split/ondemand/settle',
  method: 'POST',
};

export const UPDATE_VENDOR_URL_NEW = {
  url: `/pg/settlements/split/vendor-kyc/$vendor_id$`,
  method: 'PATCH',
};

export const GET_VENDOR_KYC_DOCS_URL = {
  url: `/pg/settlements/split/vendors/docs/$vendor_id$`,
  method: 'GET',
};

export const DOWNLOAD_DOC_URL = {
  url: `/pg/settlements/split/vendors/$vendor_id$/download/$docType$`,
  method: 'GET',
};

export const CREATE_KYC_URL = {
  url: `/pg/settlements/split/vendors/docs/$vendor_id$`,
  method: 'POST',
};

export const GET_DOCS_BY_USER_URL = {
  url: `/common/onboardingsvc/users/$userName$/documents`,
  method: 'GET',
};

export const UPLOAD_VENDOR_DOCS_URL = {
  url: `/common/onboardingsvc/users/$userName$`,
  method: 'POST',
};

export const VERIFY_PAN_URL = {
  url: '/common/onboardingsvc/verification/pan',
  method: 'POST',
};

export const VERIFY_CIN_URL = {
  url: '/common/onboardingsvc/verification/cin',
  method: 'POST',
};

export const VERIFY_GST_URL = {
  url: '/common/onboardingsvc/verification/gstin',
  method: 'POST',
};

export const CREATE_ONBOARDING_USER_URL = {
  url: '/common/onboardingsvc/user',
  method: 'POST',
};

export const VENDOR_STATUS = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  DELETED: 'DELETED',
};

export const UPDATE_VENDOR_FIELDS = [
  'email',
  'status',
  'accountNumber',
  'accountHolder',
  'ifsc',
  'phone',
  'name',
  'scheduleOption',
  'vpa',
  'verifyAccount',
  'cin',
  'gst',
  'voterId',
  'drivingLicense',
  'passport',
  'uidai',
  'pan',
  'businessType',
  'accountType',
  'updatedBy',
];

export const IN_BENE_UPDATE_VENDOR_FIELDS = [
  'email',
  'status',
  'phone',
  'name',
  'scheduleOption',
  'verifyAccount',
  'cin',
  'gst',
  'voterId',
  'drivingLicense',
  'passport',
  'uidai',
  'pan',
  'businessType',
  'accountType',
  'updatedBy',
];

export const IN_BENE_CREATION = 'IN_BENE_CREATION';

export const BATCH_DOWNLOAD_URL = {
  url: '/pg/orders/batch/file/$file_id$',
  method: 'GET',
};

export const UPLOAD_BATCH_FILE_CHECKLIST = [
  'Max no. of records: 200',
  'Max file size: 8 MB',
  'File type: .csv',
];

export const BATCH_UPLOAD_MODAL_TITLE_MAPPER = {
  UPLOAD_SUCCESS: {
    title: 'File Processed Successfully',
    type: 'success',
  },
  UPLOAD_FAILED: {
    title: 'File Processing Failed',
    description: ` No valid records found. Download the error log to correct all the errors and try again.`,
    type: 'danger',
  },
  UPLOAD_ERROR: {
    title: 'Errors found in the file',
    type: 'warning',
  },
  UPLOAD_CANCELLED: {
    title: 'File Upload Cancelled',
    type: 'danger',
  },
};

export const EDIT_VENDOR = 'EDIT_VENDOR';

export const DELETE_VENDOR = 'DELETE_VENDOR';

export const ADD_VENDOR = 'ADD_VENDOR';

export const ADJUSTMENT_TYPE = [
  {
    name: 'type',
    label: 'Debit',
    value: 'DEBIT',
  },
  {
    name: 'type',
    label: 'Credit',
    value: 'CREDIT',
  },
];

export const MENU_ITEMS = [
  { key: 'EDIT', text: 'Edit Vendor', value: EDIT_VENDOR },
  {
    key: 'DELETE_SPLIT',
    text: 'Delete Vendor',
    value: DELETE_VENDOR,
  },
];

export const VENDOR_OD_MAPPER = [
  {
    key: 'merchantVendorId',
    displayName: 'Vendor ID',
  },
  {
    key: 'existingVendorBalance',
    displayName: 'Existing Vendor Balance',
  },
  {
    key: 'serviceCharge',
    displayName: 'On Demand Service Charge',
  },
  {
    key: 'serviceTax',
    displayName: 'On Demand Service Tax',
  },
  {
    key: 'nextSettlementDate',
    displayName: 'Upcoming Settlement Time',
  },
];

export const TIME_DROPDOWN_OPTIONS = [
  {
    key: '0AM',
    text: '00 AM',
    value: '00:00:00',
  },
  {
    key: '1AM',
    text: '01 AM',
    value: '01:00:00',
  },
  {
    key: '2AM',
    text: '02 AM',
    value: '02:00:00',
  },
  {
    key: '3AM',
    text: '03 AM',
    value: '03:00:00',
  },
  {
    key: '4AM',
    text: '04 AM',
    value: '04:00:00',
  },
  {
    key: '5AM',
    text: '05 AM',
    value: '05:00:00',
  },
  {
    key: '6AM',
    text: '06 AM',
    value: '06:00:00',
  },
  {
    key: '7AM',
    text: '07 AM',
    value: '07:00:00',
  },
  {
    key: '8AM',
    text: '08 AM',
    value: '08:00:00',
  },
  {
    key: '9AM',
    text: '09 AM',
    value: '09:00:00',
  },
  {
    key: '10AM',
    text: '10 AM',
    value: '10:00:00',
  },
  {
    key: '11AM',
    text: '11 AM',
    value: '11:00:00',
  },
  {
    key: '12AM',
    text: '12 PM',
    value: '12:00:00',
  },
  {
    key: '13PM',
    text: '01 PM',
    value: '13:00:00',
  },
  {
    key: '14PM',
    text: '02 PM',
    value: '14:00:00',
  },
  {
    key: '15PM',
    text: '03 PM',
    value: '15:00:00',
  },
  {
    key: '16PM',
    text: '04 PM',
    value: '16:00:00',
  },
  {
    key: '17PM',
    text: '05 PM',
    value: '17:00:00',
  },
  {
    key: '18PM',
    text: '06 PM',
    value: '18:00:00',
  },
  {
    key: '19PM',
    text: '07 PM',
    value: '19:00:00',
  },
  {
    key: '20PM',
    text: '08 PM',
    value: '20:00:00',
  },
  {
    key: '21PM',
    text: '09 PM',
    value: '21:00:00',
  },
  {
    key: '22PM',
    text: '10 PM',
    value: '22:00:00',
  },
  {
    key: '23PM',
    text: '11 PM',
    value: '23:00:00',
  },
];

export const SETTLE_NOW_STATUS_MAPPER = {
  [SETTLE_NOW_SUCCESS]: {
    type: 'success',
    title: 'Settlement Initiated Successfully',
    description: 'You will receive the settlement within 1 hrs.',
    content: {
      addedOn: 'Initiated At',
      requestId: 'On Demand Request ID',
      settlementId: 'Settlement ID',
      status: 'Status',
    },
  },
};

export const MINIMUM_VENDOR_BALANCE = 1000;
export const VENDOR_TYPE_PG = 'PG';

export const VENDOR_STATUS_DELETED = 'DELETED';

export const SPLIT_VENDOR_EXIST_ERROR = 'SPLIT_VENDOR_EXIST';

export const VENDOR_TYPE = {
  [VENDOR_TYPE_PG]: 'PG',
  LENDER: 'LENDING_SERVICE',
};

export const EMBED_MODAL = 'EMBED_MODAL';

export const CRITICAL_BUSINESS = [
  'Insurance',
  'Mutual funds/Broking',
  'NBFCs / Organizations into Lending',
];
export const BUSINESS_TYPE_MAPPING = {
  1: 'Education',
  2: 'Government',
  3: 'Insurance',
  4: 'Jewellery',
  5: 'Gemstone/Diamond',
  6: 'Mutual funds/Broking',
  7: 'NBFCs / Organizations into Lending',
  8: 'Non Profit / NGO',
  9: 'Online Gaming',
  10: 'Open/Partial Open Wallet',
  11: 'Pharmacy',
  12: 'Travel and Hospitality',
  13: 'Utilities',
  14: 'Aggregators',
  15: 'Hemp Products / Herbal Products',
  16: 'FOREX',
  17: 'Chit Funds',
  18: 'Web host/Domain seller',
  19: 'Professional services(Doctors, Lawyers, Architects, CAs and other Professionals)',
  20: 'Food Industry',
  21: 'International Card Acceptance (Goods export)',
};
export const DOCS_ADDRESS_MAPPING = {
  1: ['UIDAI_FRONT', 'UIDAI_BACK'],
  2: ['DL'],
  3: ['VOTER_ID'],
  4: ['PASSPORT_FRONT', 'PASSPORT_BACK'],
};
export const DOC_VALUES_ON_ADDRESS = [
  ['UIDAI_FRONT', 'UIDAI_BACK'],
  ['DL'],
  ['VOTER_ID'],
  ['PASSPORT_FRONT', 'PASSPORT_BACK'],
];
export const POSSIBLE_KYC_PAYLOAD = [
  'pan',
  'uidai',
  'passport',
  'drivingLicense',
  'voterId',
  'gst',
  'cin',
  'completeFileObj',
];
export const POSSIBLE_BUSINESS_FIELDS = ['gst', 'cin'];
export const POSSIBLE_INDIVIDUAL_FIELDS = [
  'uidai',
  'drivingLicense',
  'voterId',
  'passport',
];
export const RELATED_DOCS_INPUT_MAPPING = {
  PASSPORT_NUMBER: 'passport',
  UIDAI_NUMBER: 'uidai',
  DL_NUMBER: 'drivingLicense',
  VOTER_ID_NUMBER: 'voterId',
  GSTIN_NUMBER: 'gst',
  CIN_NUMBER: 'cin',
};
export const POSSIBLE_KYC_DOCS = [
  'UIDAI_FRONT',
  'UIDAI_BACK',
  'DL',
  'PASSPORT_FRONT',
  'PASSPORT_BACK',
  'VOTER_ID',
  'GST',
  'CIN',
  'NBFC_CERTIFICATE',
];
export const ADDRESS_DOCS_API_RESPONSE = [
  'UIDAI_NUMBER',
  'DL_NUMBER',
  'VOTER_ID_NUMBER',
  'PASSPORT_NUMBER',
];
export const GENERAL_FILE_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
];
export const PASSPORT_FRONT_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload first two pages',
];
export const PASSPORT_BACK_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload last two pages',
];
export const DRIVING_LICENSE_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload the side that has the photo and the details. If both sides have the details, upload them in a single document',
];
export const VOTER_ID_CHECKLIST = [
  ' Max file size: 25 MB',
  ' File format: .png, .jpeg, .pdf, .jpg',
  ' Upload front side of the voter ID',
];
export const VALID_FILE_FORMATS = '.png,.jpeg,.pdf,.jpg';
export const POSSIBLE_BUSINESS_DOCS = ['businessPanDoc', 'GST', 'CIN'];
export const POSSIBLE_INDIVIDUAL_DOCS = [
  'PAN',
  'UIDAI_FRONT',
  'UIDAI_BACK',
  'PASSPORT_FRONT',
  'PASSPORT_BACK',
  'DL',
  'VOTER_ID',
];
export const BUSINESS_TYPE_OPTION = [
  { value: 1, text: 'Education' },
  { value: 2, text: 'Government' },
  { value: 3, text: 'Insurance' },
  { value: 4, text: 'Jewellery' },
  { value: 5, text: 'Gemstone/Diamond' },
  { value: 6, text: 'Mutual funds/Broking' },
  { value: 7, text: 'NBFCs / Organizations into Lending' },
  { value: 8, text: 'Non Profit / NGO' },
  { value: 9, text: 'Online Gaming' },
  { value: 10, text: 'Open/Partial Open Wallet' },
  { value: 11, text: 'Pharmacy' },
  { value: 12, text: 'Travel and Hospitality' },
  { value: 13, text: 'Utilities' },
  { value: 14, text: 'Aggregators' },
  { value: 15, text: 'Hemp Products / Herbal Products' },
  { value: 16, text: 'FOREX' },
  { value: 17, text: 'Chit Funds' },
  { value: 18, text: 'Web host/Domain seller' },
  {
    value: 19,
    text:
      'Professional services(Doctors, Lawyers, Architects, CAs and other Professionals)',
  },
  { value: 20, text: 'Food Industry' },
  { value: 21, text: 'International Card Acceptance (Goods export)' },
];
export const ADDRESS_PROOF_OPTIONS = [
  {
    key: 1,
    value: 1,
    text: 'Aadhaar',
  },
  {
    key: 2,
    value: 2,
    text: 'Driving License',
  },
  {
    key: 3,
    value: 3,
    text: 'Voter ID',
  },
  {
    key: 4,
    value: 4,
    text: 'Passport',
  },
];
export const VENDOR_TYPE_RADIO_DATA = {
  radioOptions: [
    {
      label: 'Business Entity',
      name: 'accountType',
      value: 'BUSINESS',
    },
    {
      label: 'Individual',
      name: 'accountType',
      value: 'INDIVIDUAL',
    },
  ],
};
export const RENDER_BUSINESS_FORM = [
  {
    input: {
      id: 'businessPan',
      name: 'businessPan',
      label: 'Business PAN',
    },
    text: 'Upload Business PAN',
    docs: {
      id: 'businessPanDoc',
      name: 'businessPanDoc',
      checkList: GENERAL_FILE_CHECKLIST,
    },
  },
  {
    input: {
      id: 'gst',
      name: 'gst',
      label: 'GST Number',
    },
    text: 'Upload GST Certificate',
    docs: {
      id: 'GST',
      name: 'GST',
      checkList: GENERAL_FILE_CHECKLIST,
    },
  },
  {
    input: {
      id: 'cin',
      name: 'cin',
      label: 'CIN Number',
    },
    text: 'Upload CIN Certificate',
    docs: {
      id: 'CIN',
      name: 'CIN',
      checkList: GENERAL_FILE_CHECKLIST,
    },
  },
];
export const RENDER_INDIVIDUAL_FORM = [
  {
    addressProof: 1,
    input: {
      id: 'uidai',
      name: 'uidai',
      label: 'Aadhaar Number',
    },
    docs: [
      {
        id: 'UIDAI_FRONT',
        name: 'UIDAI_FRONT',
        text: 'FrontSide of Aadhaar',
        checkList: GENERAL_FILE_CHECKLIST,
      },
      {
        id: 'UIDAI_BACK',
        name: 'UIDAI_BACK',
        text: 'BackSide of Aadhaar',
        checkList: GENERAL_FILE_CHECKLIST,
      },
    ],
  },
  {
    addressProof: 2,
    input: {
      id: 'drivingLicense',
      name: 'drivingLicense',
      label: 'Driving License Number',
    },
    docs: [
      {
        id: 'DL',
        name: 'DL',
        text: 'Upload Driving License',
        checkList: DRIVING_LICENSE_CHECKLIST,
      },
    ],
  },
  {
    addressProof: 3,
    input: {
      id: 'voterId',
      name: 'voterId',
      label: 'Voter ID Number',
    },
    docs: [
      {
        id: 'VOTER_ID',
        name: 'VOTER_ID',
        text: 'Upload Voter ID',
        checkList: VOTER_ID_CHECKLIST,
      },
    ],
  },
  {
    addressProof: 4,
    input: {
      id: 'passport',
      name: 'passport',
      label: 'Passport Number',
    },
    docs: [
      {
        id: 'PASSPORT_FRONT',
        name: 'PASSPORT_FRONT',
        text: 'FrontSide of Passport',
        checkList: PASSPORT_FRONT_CHECKLIST,
      },
      {
        id: 'PASSPORT_BACK',
        name: 'PASSPORT_BACK',
        text: 'BackSide of Passport',
        checkList: PASSPORT_BACK_CHECKLIST,
      },
    ],
  },
];
export const INDIVIDUAL = 'INDIVIDUAL';
export const BUSINESS = 'BUSINESS';
export const PAN = 'PAN';
export const NBFC_CERTIFICATE = 'NBFC_CERTIFICATE';
export const NBFC_TEXT = 'NBFCs / Organizations into Lending';
export const PAN_NUMBER = 'PAN_NUMBER';
export const PAN_NAME = 'pan';
export const BUSINESS_PAN = 'businessPan';
export const BUSINESS_PAN_DOC = 'businessPanDoc';
export const FILE_SIZE = 25;
export const KYC_VALIDATION_REQUIRED_MSG = 'This is a required field';
export const IN_KYC_REVIEW = 'IN_KYC_REVIEW';
export const IN_REVIEW = 'IN_REVIEW';
export const SAMPLE_REGEX_INPUT_MAPPING = {
  pan: 'BNZAA2318J',
  uidai: '367598346012',
  passport: 'A2096457',
  drivingLicense: 'HR0619850034761',
  voterId: 'XGN3002623',
  gst: '06BZAHM6385P6Z2',
  cin: 'U12345AB6784CDE123456',
  businessPan: 'BNZAA2318J',
};

export const VENDOR_STATUS_HOVER_INFO = 'to know more about vendor statuses.';

export const VENDOR_STATUS_INFO_LINK =
  'https://www.cashfree.com/docs/payments/split/vendor/add';

export const VENDOR_DASHBOARD_INFO_LINK =
  'https://www.cashfree.com/docs/payments/split/vendor/dashboard/overview#vendor-dashboard';

export const VENDOR_SETTLEMENT_CYCLE_INFO_LINK =
  'https://docs.cashfree.com/reference/create-vendor-v20';

export const VENDOR_BUSINESS_TYPE_INFO_LINK =
  'https://www.cashfree.com/docs/payments/split/vendor/add#vendor-type';

export const VENDOR_LOB_INFO_LINK =
  'https://www.cashfree.com/docs/payments/split/vendor/add#list-of-vendor-line-of-business-lob';

export const VENDOR_STATUS_MAPPING = {
  IN_KYC_REVIEW: 'In KYC Review',
  ACTION_REQUIRED: 'Action Required',
};

export const VENDOR_STATUS_INFO_HEADING_MAPPING = {
  ACTION_REQUIRED: 'Complete Activation',
  IN_KYC_REVIEW: 'In KYC Review',
};

export const VENDOR_STATUS_COLOR_MAPPING = {
  ACTION_REQUIRED: 'danger',
  ACTIVE: 'success',
  BENE_CREATION_FAILED: 'danger',
  ON_HOLD: 'warning',
  DELETED: 'danger',
  BANK_VALIDATION_FAILED: 'warning',
};

export const SHOW_INFO_STATUSES = [
  'IN_KYC_REVIEW',
  'ACTION_REQUIRED',
  'BENE_CREATION_FAILED',
  'IN_BENE_CREATION',
  'ACTIVE',
  'BLOCKED',
  'ON_HOLD',
];

export const VENDOR_STATUS_INFO_MAPPING = {
  IN_KYC_REVIEW:
    'Submitted documents are currently under review. Incase you have not submitted all the documents, submit them now for vendor activation.',
  ACTION_REQUIRED: 'Documents needed to be submitted against this vendor.',
  BENE_CREATION_FAILED:
    'Beneficiary creation at the partner bank has failed. Update bank account details to retry new beneficiary creation.',
  IN_BENE_CREATION:
    'Vendor beneficiary creation is currently in progress at the partner bank.',
  ACTIVE: 'Vendor is Active',
  BLOCKED:
    'Vendor is blocked. Unblock the vendor to continue processing settlements.',
  ON_HOLD:
    'vendor account is currently put on hold. You cannot process any settlements to this account.',
  DELETED: 'Vendor is Deleted.',
  INACTIVE: 'Vendor is inactive.',
  IN_BANK_VALIDATION:
    'Bank details added are being validated at our end. Status will change once validation is complete.',
  BANK_VALIDATION_FAILED:
    'The bank details provided are not valid. Please verify bank details provided in vendor details page and retry validation.',
};

// export const VENDOR_STATUS_TOGGLE_INFO_MAPPING = {
//   IN_KYC_REVIEW:
//     'Vendor will be active once the documents are verified & the beneficiary is created at our end.',
//   ACTION_PENDING: 'Complete the pending actions to activate this vendor.',
//   BENE_CREATION_FAILED: 'failed.',
//   IN_BENE_CREATION:
//     'Vendor will be active once the beneficiary is created at our end.',
//   ACTIVE: 'Turn off the toggle to block the vendor.',
//   BLOCKED: 'Turn on the toggle to activate the vendor.',
//   DELETED: 'Vendor is Deleted.',
// };

export const SHOW_TAKE_ACTION_CTA = [
  'IN_KYC_REVIEW',
  'ACTION_REQUIRED',
  'BENE_CREATION_FAILED',
];

export const VENDOR_LINE_OF_BUSINESS_OPTIONS = [
  { key: 1, text: 'B2B', value: 'B2B' },
  { key: 2, text: 'Digital Goods', value: 'Digital Goods' },
  { key: 3, text: 'E-commerce', value: 'E-commerce' },
  { key: 4, text: 'Education', value: 'Education' },
  { key: 5, text: 'Financial Services', value: 'Financial Services' },
  { key: 6, text: 'Food and Beverages', value: 'Food and Beverages' },
  { key: 7, text: 'Gaming', value: 'Gaming' },
  { key: 8, text: 'Government', value: 'Government' },
  { key: 9, text: 'Grocery', value: 'Grocery' },
  { key: 10, text: 'Healthcare', value: 'Healthcare' },
  { key: 11, text: 'Insurance', value: 'Insurance' },
  { key: 12, text: 'Jewellery', value: 'Jewellery' },
  {
    key: 13,
    text: 'NBFCs/Organizations into Lending',
    value: 'NBFCs/Organizations into Lending',
  },
  { key: 14, text: 'Logistics', value: 'Logistics' },
  { key: 15, text: 'Miscellaneous', value: 'Miscellaneous' },
  { key: 16, text: 'Mutual funds/Broking', value: 'Mutual funds/Broking' },
  { key: 17, text: 'Non Profit/NGO', value: 'Non Profit/NGO' },
  { key: 18, text: 'Online Gaming', value: 'Online Gaming' },
  {
    key: 19,
    text: 'Open and Semi Open Wallet',
    value: 'Open and Semi Open Wallet',
  },
  { key: 20, text: 'Pan shop', value: 'Pan shop' },
  { key: 21, text: 'Pharmacy', value: 'Pharmacy' },
  { key: 22, text: 'Readymade', value: 'Readymade' },
  {
    key: 23,
    text: 'Real Estate, Housing, Rentals',
    value: 'Real Estate, Housing, Rentals',
  },
  { key: 24, text: 'Retail and Shopping', value: 'Retail and Shopping' },
  { key: 25, text: 'SaaS', value: 'SaaS' },
  {
    key: 26,
    text: 'Social Media and Entertainment',
    value: 'Social Media and Entertainment',
  },
  {
    key: 27,
    text: 'Society/Trust/Club/Association',
    value: 'Society/Trust/Club/Association',
  },
  { key: 28, text: 'Telecom', value: 'Telecom' },
  { key: 29, text: 'Travel and Hospitality', value: 'Travel and Hospitality' },
  { key: 30, text: 'Utilities', value: 'Utilities' },
  { key: 31, text: 'Chit Funds', value: 'Chit Funds' },
  { key: 32, text: 'Web host/Domain seller', value: 'Web host/Domain seller' },
  {
    key: 33,
    text:
      'Professional Services (Doctors, Lawyers, Architects, CAs, and other Professionals)',
    value:
      'Professional Services (Doctors, Lawyers, Architects, CAs, and other Professionals)',
  },
];

export const VENDOR_BUSINESS_TYPE_OPTIONS = [
  {
    key: 1,
    text: 'Govt Authority/ULBs/Municipalities',
    description:
      'You have an official business registration number and maintain a dedicated business bank account.',
    value: 'Govt Authority/ULBs/Municipalities',
  },
  {
    key: 2,
    text: 'Individual',
    description:
      'You are the proprietor and operator of the business, and hold a personal bank account.',
    value: 'Individual',
  },
  {
    key: 3,
    text: 'LLP or Partnership',
    description:
      'You are registered as a Limited Liability Partnership (LLP) and possess a unique business registration number, and hold a business bank account.',
    value: 'LLP',
  },
  {
    key: 4,
    text: 'Private Ltd or Public Ltd',
    description:
      'You possess both a business registration number and a dedicated business bank account.',
    value: 'Private Ltd or Public Ltd',
  },
  {
    key: 5,
    text: 'Proprietorship',
    description:
      'You are the business owner, operator, and hold a personal bank account.',
    value: 'Proprietorship',
  },
  {
    key: 6,
    text: 'Society/Trust/Clubs/NGO/Association',
    description:
      'You hold a business registration number and maintain a dedicated business bank account.',
    value: 'Society/Trust/Clubs/NGO/Association',
  },
];

export const SHOW_COMPLETE_ACTIVATION_CTA = [
  'IN_KYC_REVIEW',
  'BENE_CREATION_FAILED',
  'ACTION_REQUIRED',
  'BANK_VALIDATION_FAILED',
];

export const INPUT_PLACEHOLDER_MAPPING = {
  PAN: 'Eg - AAAPL1234C',
  CIN: 'Eg - L17110MH1973PLC019786',
  GSTIN: 'Eg - L17110MH1973PLC019786',
};

export const GSTIN_INFO_TEXT =
  "Note: You will need to upload your GSTIN when your vendor's GMV exceeds 20L. Uploading it now will help ensure the seamless operation of your vendor account.";

export const MERCHANT_VENDOR_AGREEMENT_INFO_TEXT =
  "Note: You are required to upload the Merchant-Vendor Agreement when your vendor's GMV exceeds 30L. Uploading it now will help ensure the seamless operation of your vendor account.";

export const SAVE_AND_EXIT_BTN_INFO_TEXT =
  "Use 'Save & Exit' to save your progress and return later to submit KYC.";

export const STATUS_COLOR_MAPPING = {
  VERIFIED: 'success',
  ACTION_REQUIRED: 'danger',
  DUE_CURRENTLY: 'warning',
};

export const STATUS_TEXT_DISPLAY_MAPPING = {
  IN_KYC_REVIEW: 'In Review',
};

export const ACTION_REQUIRED = 'ACTION_REQUIRED';

export const VERIFIED = 'VERIFIED';

export const BENE_CREATION_FAILED = 'BENE_CREATION_FAILED';

export const SUBMIT_KYC_FOR_REVIEW = 'SUBMIT_KYC_FOR_REVIEW';

export const KYC_PENDING = 'KYC_PENDING';

export const BANK_DETAILS = ['ifsc', 'vpa', 'accountNumber', 'name'];

export const DELETE_BANK_DETAILS = [
  'ifsc',
  'vpa',
  'accountNumber',
  'name',
  'accountHolder',
];

export const CIN = 'CIN';

export const GSTIN = 'GSTIN';

export const VALUE = 'VALUE';

export const AUTO_VERIFIED_DOCS = ['PAN', 'CIN', 'GSTIN'];
